var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isValid
    ? _c("div", { staticClass: "trbo-a-range" }, [
        _c("div", { staticClass: "trbo-a-range__inputs" }, [
          _c("div", { staticClass: "trbo-a-range__inputs__item" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputLower,
                  expression: "inputLower",
                },
              ],
              staticClass: "trbo-a-range__inputs__item__input",
              style: _vm.inputStyles,
              attrs: { type: "number", "aria-label": "Minimum" },
              domProps: { value: _vm.inputLower },
              on: {
                blur: _vm.formatLower,
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.handleLowerSubmit.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.inputLower = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                ref: "lowerUnitSymbol",
                staticClass: "trbo-a-range__inputs__item__metric-symbol",
              },
              [_vm._v("\n        " + _vm._s(_vm.unitSymbol) + "\n      ")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "trbo-a-range__inputs__item" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputHigher,
                  expression: "inputHigher",
                },
              ],
              staticClass: "trbo-a-range__inputs__item__input",
              style: _vm.inputStyles,
              attrs: { type: "number", "aria-label": "Maximum" },
              domProps: { value: _vm.inputHigher },
              on: {
                blur: _vm.formatHigher,
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.handleHigherSubmit.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.inputHigher = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "trbo-a-range__inputs__item__metric-symbol" },
              [_vm._v("\n        " + _vm._s(_vm.unitSymbol) + "\n      ")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "trbo-a-range__range" },
          [
            _c("vue-slider", {
              attrs: {
                tooltip: "none",
                "dot-size": 16,
                min: _vm.minValue,
                max: _vm.maxValue,
                interval: _vm.stepSize,
                "min-range": _vm.stepSize,
              },
              on: { change: _vm.onSliderChange },
              model: {
                value: _vm.range,
                callback: function ($$v) {
                  _vm.range = $$v
                },
                expression: "range",
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }